import {
    CompleteMultipartUploadCommand,
    CreateMultipartUploadCommand,
    CreateMultipartUploadCommandInput,
    MultipartUpload,
    S3Client,
    UploadPartCommand,
} from '@aws-sdk/client-s3'
import type { StreamingBlobPayloadInputTypes } from '@smithy/types'

import { getCredentials, REGION } from 'src/services/aws/credentials'

/* istanbul ignore next */
export const getS3Client = async (): Promise<S3Client> => {
    return new S3Client({
        region: REGION,
        credentials: await getCredentials(),
    })
}

export const multipartUpload = async (
    client: S3Client,
    file: StreamingBlobPayloadInputTypes,
    config: CreateMultipartUploadCommandInput
) => {
    const upload: MultipartUpload = await client.send(new CreateMultipartUploadCommand(config))
    // Convert Blob/File to Uint8Array for AWS SDK v3 compatibility.
    // The newer SDK's flexibleChecksumsMiddleware treats any body that isn't a
    // string/ArrayBuffer/ArrayBufferView as "streaming", which adds unsigned
    // headers (x-amz-decoded-content-length) causing S3 signature errors.
    // Converting to Uint8Array ensures the non-streaming checksum path is used.
    const body =
        file instanceof Blob && typeof file.arrayBuffer === 'function'
            ? new Uint8Array(await file.arrayBuffer())
            : file
    const uploadPart = await client.send(
        new UploadPartCommand({
            ...config,
            UploadId: upload.UploadId,
            PartNumber: 1,
            Body: body,
        })
    )
    return await client.send(
        new CompleteMultipartUploadCommand({
            ...config,
            UploadId: upload.UploadId,
            MultipartUpload: {
                Parts: [
                    {
                        ETag: uploadPart.ETag,
                        PartNumber: 1,
                    },
                ],
            },
        })
    )
}
